import React from 'react';
export function useDataTablePagination(props) {
    var _a, _b, _c, _d;
    const defaultRowsPerPage = (_a = props.defaultRowsPerPage) !== null && _a !== void 0 ? _a : 5;
    const defaultPage = (_b = props.defaultPage) !== null && _b !== void 0 ? _b : 0;
    const rowsPerPageOptions = (_c = props.rowsPerPageOptions) !== null && _c !== void 0 ? _c : [5, 10, 20, 50];
    const totalRowCount = (_d = props.totalRowCount) !== null && _d !== void 0 ? _d : 500;
    const [page, setPage] = React.useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage);
    const rows = paginate({ page, pageSize: rowsPerPage, rowsAll: props.rows });
    return {
        totalRowCount,
        rows,
        page,
        onPageChange: setPage,
        rowsPerPage,
        rowsPerPageOptions,
        onRowsPerPagePageChange: setRowsPerPage,
    };
}
function paginate({ page, pageSize, rowsAll }) {
    const clonedArray = structuredClone(rowsAll);
    const start = page * pageSize;
    const end = start + pageSize;
    return clonedArray.slice(start, end);
}
